import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { INSURANCE_CONDITIONS_LINKS } from '../../../../../constants/settings';
import InsuranceLogo from '../../../../components/insurance/booking/InsuranceLogo';
import { INSURANCE_REFUNDED, INSURANCE_REFUND_PROCESS } from './helper';
import Button from '../../../../directives/Button/Button';
import * as Styled from './Style';
class OrderInsurance extends PureComponent {
  static propTypes = {
    insurance: PropTypes.object.isRequired,
    downloadPath: PropTypes.string,
    errorText: PropTypes.string,
    isRetriable: PropTypes.bool,
    refundStatus: PropTypes.string,
    isRefunding: PropTypes.bool.isRequired,
    onRefund: PropTypes.func.isRequired,
    isDownloadButtonShown: PropTypes.bool.isRequired
  };
  state = {
    isRefundConfirmRequired: false
  };
  onConfirmToggle = () => this.setState({
    isRefundConfirmRequired: !this.state.isRefundConfirmRequired
  });
  render() {
    const {
      insurance,
      downloadPath,
      errorText,
      isRetriable,
      refundStatus,
      isRefunding,
      onRefund,
      isDownloadButtonShown
    } = this.props;
    const {
      isRefundConfirmRequired
    } = this.state;
    const {
      company,
      kind,
      'refund-allowed': refundAllowed
    } = insurance;
    let appearance = 'default';
    let title = '';
    let description = I18n.t(`components.OrderInsurance.${company}_${kind}.description`, {
      conditions_link: INSURANCE_CONDITIONS_LINKS[`${company}_${kind}`]
    });
    let mainActionText = '';
    let onMainActionHandler = null;
    if (refundStatus === INSURANCE_REFUNDED) {
      appearance = 'returned';
      mainActionText = I18n.t('components.OrderInsurance.ok');
    } else if (refundStatus === INSURANCE_REFUND_PROCESS) {
      appearance = 'status';
      description = I18n.t('components.OrderInsurance.refund_process');
    } else if (errorText) {
      appearance = 'returned';
      description = errorText;
      if (isRetriable) {
        mainActionText = I18n.t('components.OrderInsurance.try_again');
        onMainActionHandler = onRefund;
      }
    } else if (isRefundConfirmRequired) {
      appearance = 'return';
      title = I18n.t('components.OrderInsurance.refund_confirm.title');
      description = I18n.t('components.OrderInsurance.refund_confirm.description');
    }
    const logo = /*#__PURE__*/React.createElement(InsuranceLogo, {
      name: company,
      alt: `logo-${company}`
    });
    const isActionsShown = appearance === 'default' && (refundAllowed || downloadPath);
    const isConfirmShown = appearance === 'return';
    return /*#__PURE__*/React.createElement(Styled.OrderInsurance, {
      appearance: appearance
    }, /*#__PURE__*/React.createElement(Styled.LogoHead, null, logo), /*#__PURE__*/React.createElement(Styled.Body, null, /*#__PURE__*/React.createElement(Styled.Logo, null, logo), /*#__PURE__*/React.createElement(Styled.Content, null, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("b", null, title, ' '), /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: description
      }
    }))), mainActionText && /*#__PURE__*/React.createElement(Styled.RemoveWrapper, null, /*#__PURE__*/React.createElement(Button, {
      isLoading: isRetriable && isRefunding,
      isDisabled: isRefunding,
      onClick: onMainActionHandler
    }, mainActionText))), isActionsShown && /*#__PURE__*/React.createElement(Styled.Actions, null, refundAllowed && /*#__PURE__*/React.createElement(Button, {
      onClick: this.onConfirmToggle
    }, I18n.t('components.OrderInsurance.refund')), downloadPath && isDownloadButtonShown && /*#__PURE__*/React.createElement(Styled.ActionLink, {
      href: downloadPath,
      target: "_blank",
      rel: "noopener noreferrer",
      hasMarginLeft: true
    }, I18n.t('components.OrderInsurance.download_insurance'))), isConfirmShown && /*#__PURE__*/React.createElement(Styled.Actions, {
      hasSmallButtons: true
    }, /*#__PURE__*/React.createElement(Button, {
      isDisabled: isRefunding,
      onClick: this.onConfirmToggle
    }, I18n.t('components.OrderInsurance.cancel')), /*#__PURE__*/React.createElement(Button, {
      isLoading: isRefunding,
      isDisabled: isRefunding,
      onClick: onRefund
    }, I18n.t('components.OrderInsurance.refund_insurance'))));
  }
}
export default OrderInsurance;